import {AxiosInstance, AxiosResponse} from "axios";
import {HospitalPatientFile, HospitalPatientFileType} from "@/core/interfaces/hospital/HospitalPatientFile";

export interface UploadHospitalPatientFile {
    type_id: number;
    files: File[];
}

export default function (hdsClient: AxiosInstance) {
    return {
        /**
         * Get the hospital patient files for a given consumer key.
         *
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async index(consumerKey: string): Promise<HospitalPatientFile[]> {
            return hdsClient
                .get(`consumers/${consumerKey}/hospital-patient-files`)
                .then((response: AxiosResponse) => response.data.data);
        },

        /**
         * Get the hospital patient file for a given id.
         */
        async download(file: { id: number }): Promise<Blob> {
            return hdsClient
                .get(`hospital-patient-files/${file.id}`, {responseType: 'blob'})
                .then((response: AxiosResponse) => response.data);
        },

        /**
         * Get the hospital patient file types.
         */
        async fileTypes(): Promise<HospitalPatientFileType[]> {
            return hdsClient
                .get(`hospital-patient-file-types`)
                .then((response: AxiosResponse) => response.data.data);
        },

        /**
         * Upload a new hospital patient file.
         */
        async uploadFile(sharingId: number, data: UploadHospitalPatientFile): Promise<HospitalPatientFile[]> {
            const formData = new FormData();
            formData.append("type_id", data.type_id.toString());
            data.files.forEach((file: File) => {
                formData.append("files[]", file);
            });

            return hdsClient
                .post(`sharings/${sharingId}/hospital-patient-files`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}
